import React from 'react';
import './services.css'
import ServicesCard from './ServicesCard';
import Slider from "react-slick";

const WORK_EXPERIENCE = [
  {
    title:"Software Engineer | Prolific Tech Solution",
    date: "Mar 2020 – Jul 2025",
    responsibilities: [
      "Designed, built, and maintained 40+ production web applications serving thousands of concurrent users, owning the full SDLC from requirements and architecture through deployment and operations.",
      "Built and maintained microservices and cloud-native architectures on AWS, using Lambda, PostgreSQL, and S3 to deliver distributed systems.",
      "Integrated AI tools via OpenAI APIs and Hugging Face Transformers to deliver features including real-time content generation and recommendation workflows.",
      "Built CI/CD pipelines enabling continuous deployment with automated testing, rollback strategies, and production monitoring, cutting release cycle times significantly.",
      "Delivered Onnow.io, a restaurant management platform with optimized component architecture and state management, achieving a 3x improvement in order processing throughput.",
      "Improved system performance by 40%+ through code-splitting, lazy loading, bundle optimization, and database query tuning.",
      "Launched Bangla App to 5,000+ downloads within 3 months through agile iteration and user feedback loops.",
    ],
  },
  {
    title:"Software Development Intern | FinX Australia",
    date: "Mar 2023 – Sep 2023",
    responsibilities: [
      "Developed and deployed smart contract systems (Solidity, Web3.js) on cloud infrastructure, following version control, code review, and documentation practices.",
      "Redesigned the product interface using React and Tailwind CSS with a component-driven architecture, reducing bounce rate by 25% and improving cross-browser reliability.",
      "Collaborated with backend engineers to design and integrate RESTful APIs, authentication flows, and real-time state management in an agile team.",
    ],
  },
  {
    title:"Technical Account Manager | iPrice Group",
    date: "Mar 2022 – Sep 2022",
    responsibilities: [
      "Built automated data integration pipelines using Python and the ELK Stack for 1,000+ merchants and 110M+ products, cutting processing time by 30% through algorithmic optimization.",
      "Deployed microservices on AWS Lambda to improve system scalability and resilience, and refactored legacy internal tools to boost throughput by 20%.",
      "Onboarded 30+ merchant partners through technical documentation and API integration support, expanding catalogue coverage by 10%.",
    ],
  },
];

const Services = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    responsive:[
      {
        breakpoint: 700,
        settings:{
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section id='services' className='experience-container'>
      <h5>Career Highlights</h5>
      <h2>Professional Experience</h2>
      <p className='experience-intro'>
        Engineering roles across product development, cloud systems, and AI-enabled solutions.
      </p>
      <div className='experience-content'>
        <Slider {...settings}>
        {WORK_EXPERIENCE.map((item) => (
          <ServicesCard key={item.title} details={item} />
        ))}
        </Slider>
      </div>
    </section>
  )
}

export default Services
